
<!-- Reusable upload-on-select status indicator (FR1/FR5). Pass the control name as context. -->
<ng-template #uploadStatus let-c>
  <div class="mt-1" *ngIf="uploadState[c]">
    <span *ngIf="uploadState[c] === 'uploading'" class="text-secondary small"><i class="fa fa-spinner fa-spin"></i> Uploading…</span>
    <span *ngIf="uploadState[c] === 'uploaded'" class="text-success small"><i class="fa fa-check-circle"></i> Uploaded</span>
    <span *ngIf="uploadState[c] === 'error'" class="text-danger small"><i class="fa fa-times-circle"></i> {{ uploadError[c] || 'Upload failed — please re-select the file.' }}</span>
  </div>
</ng-template>

<div class="row">

  <form *ngIf="formResetToggle" class="login" name="loginForm"
        [formGroup]="icdForm" (ngSubmit)="onSubmit()" novalidate>


        <div class="row">
          <div class="col-sm-4">
            <div class="form-check mb-3">
              <input type="radio" formControlName="US_or_CA" value="US" id="US_or_CA" (change)="onCountryChange()" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f.US_or_CA.errors }" />

              <label for="acceptTerms" class="form-check-label">US</label><br />
              <input type="radio" formControlName="US_or_CA" value="Canada" id="US_or_CA" (change)="onCountryChange()" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f.US_or_CA.errors }" />
              <label for="acceptTerms" class="form-check-label">Canada  <code>*</code></label>
              <div *ngIf="submitted && f.US_or_CA.errors" class="invalid-feedback">US or Canada is required</div>
            </div>
          </div>

        </div>


        <div class="card card-secondary">
          <div class="card-header">
            <h3 class="card-title">ICD Info</h3>

            <div class="card-tools">
              <button type="button" class="btn btn-tool" data-card-widget="collapse">
                <i class="fas fa-minus"></i>
              </button>
            </div>
          </div>
          <!-- /.card-header -->
          <div class="card-body">


            <div class="row">
              <div class="col-sm-4">
                <div class="form-group">

                  <label class="col-form-label  col-md-12" for="login-Full_Legal_Company_Name">ICD Corporation Name <code>*</code></label>
                  <input type="text" formControlName="Full_Legal_Company_Name" class="form-control"
                         [ngClass]="{'is-valid': f.Full_Legal_Company_Name.valid, 'is-invalid' : submitted && f.Full_Legal_Company_Name.valid}" placeholder="Enter Full Legal Company Name"
                         appAiHint="Full Legal Company Name" [aiHintForm]="icdForm" />
                  <div *ngIf="submitted && f.Full_Legal_Company_Name.errors" class="invalid-feedback">
                    <div *ngIf="f.Full_Legal_Company_Name.errors.required">Full Legal Company Name  is required</div>
                  </div>

                </div>




              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-ICD_Owner_Name">ICD Owner's Name <code>*</code></label>
                  <input type="text" formControlName="ICD_Owner_Name" class="form-control"
                         [ngClass]="{'is-valid': f.ICD_Owner_Name.valid, 'is-invalid' : submitted && f.ICD_Owner_Name.valid}"
                         placeholder="Enter  Owner  Name"
                         appAiHint="ICD Owner Name" [aiHintForm]="icdForm" />
                  <div *ngIf="submitted && f.ICD_Owner_Name.errors" class="invalid-feedback">
                    <div *ngIf="f.ICD_Owner_Name.errors.required">Owner  Name is required</div>
                  </div>

                </div>
              </div>

              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-HUB_Manager_Contact_Name">Hub Name<code>*</code></label>
                  <div class="col-md-12">
                    <input type="text" formControlName="HUB_Manager_Contact_Name" id="login-HUB_Manager_Contact_Name" name="HUB_Manager_Contact_Name" placeholder="Enter Hub Name" autocomplete="HUB_Manager_Contact_Name"
                           class="form-control"
                           appAiHint="HUB Manager Contact Name" [aiHintForm]="icdForm" />

                  </div>
                </div>
              </div>

              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-Promoting_Owner">Promoting Owner<code>*</code></label>
                  <div class="col-md-12">
                    <ng-select [searchable]="true" formControlName="Promoting_Owner" (change)="onCheckboxPo($event)">
                      <ng-option *ngFor="let o of PO_namesData"
                                 [value]="o.ownerName">
                        {{ o.ownerNameCompany }}
                      </ng-option>
                    </ng-select>

                    <div *ngIf="submitted && f.Promoting_Owner.errors" class="invalid-feedback">
                      <div *ngIf="f.Promoting_Owner.errors.required">Promoting Owner is required</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-Promoting_Owner">Promoting Owner's Company<code>*</code></label>
                  <div class="col-md-12">
                    <input type="text" formControlName="Promoting_Owner_Company" class="form-control"
                           [ngClass]="{'is-valid': f.Promoting_Owner_Company.valid, 'is-invalid' : submitted && f.Promoting_Owner_Company.valid}" placeholder="Enter Promoting Owner Company"
                           appAiHint="Promoting Owner Company" [aiHintForm]="icdForm" />
                    <div *ngIf="submitted && f.Promoting_Owner_Company.errors" class="invalid-feedback">
                      <div *ngIf="f.Promoting_Owner_Company.errors.required">Promoting  Company is required</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-Regional_Consultant">Regional Consultant</label>
                  <div class="col-md-12">

                    <ng-select [searchable]="true" formControlName="Regional_Consultant"
                               (change)="onCheckboxRC($event)">
                      <ng-option *ngFor="let o of RC_namesData"
                                 [value]="o.ownerName">
                        {{ o.ownerNameCompany }}
                      </ng-option>
                    </ng-select>
                    <div *ngIf="submitted && f.Regional_Consultant.errors" class="invalid-feedback">
                      <div *ngIf="f.Regional_Consultant.errors.required">Regional Consultant is required</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-Regional_Consultant">Regional Consultant's Company</label>
                  <div class="col-md-12">
                    <input type="text" formControlName="Regional_Consultant_Company" class="form-control"
                           placeholder="Enter Regional Consultant Company"
                           appAiHint="Regional Consultant Company" [aiHintForm]="icdForm" />
                    <div *ngIf="submitted && f.Regional_Consultant_Company.errors" class="invalid-feedback">
                      <div *ngIf="f.Regional_Consultant_Company.errors.required">Regional Consultant Company is required</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-National_Consultant">National Consultant<code>*</code></label>
                  <div class="col-md-12">


                    <ng-select [searchable]="true" formControlName="National_Consultant" [ngClass]="{ 'is-invalid': submitted && f.National_Consultant.errors }"
                               (change)="onCheckboxNC($event)">
                      <ng-option *ngFor="let o of NC_namesData"
                                 [value]="o.ownerName">
                        {{ o.ownerNameCompany }}
                      </ng-option>
                    </ng-select>

                    <div *ngIf="submitted && f.National_Consultant.errors" class="invalid-feedback">
                      <div *ngIf="f.National_Consultant.errors.required">National Consultant is required</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-National_Consultant">National Consultant's Company<code>*</code></label>
                  <div class="col-md-12">
                    <input type="text" formControlName="National_Consultant_Company" class="form-control"
                           [ngClass]="{'is-valid': f.National_Consultant_Company.valid, 'is-invalid' : submitted && f.National_Consultant_Company.valid}" placeholder="Enter National Consultant Company"
                           appAiHint="National Consultant Company" [aiHintForm]="icdForm" />
                    <div *ngIf="submitted && f.National_Consultant_Company.errors" class="invalid-feedback">
                      <div *ngIf="f.National_Consultant_Company.errors.required">National Consultant Company is required</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-4">

                <div class="form-group">

                  <label class="col-form-label  col-md-12" for="login-Tax_ID">F.E.I.N. # (Tax ID)/Business # <code>*</code></label>
                  <input type="text" formControlName="Tax_ID" class="form-control"
                         [ngClass]="{'is-valid': f.Tax_ID.valid, 'is-invalid' : submitted && f.Tax_ID.valid}" placeholder="Enter  F.E.I.N. # (Tax ID)/Business" />
                  <div *ngIf="submitted && f.Tax_ID.errors" class="invalid-feedback">
                    <div *ngIf="f.Tax_ID.errors.required">F.E.I.N. # (Tax ID)/Business #  is required</div>
                  </div>


                </div>
              </div>
              <div class="col-sm-4" *ngIf="selectedCountry == 'US'">

                <div class="form-group">

                  <label class="col-form-label  col-md-12" for="login-State_UI_ID">State UI ID#(Required for CO/FL/MN/NY)</label>
                  <input type="text" formControlName="State_UI_ID" class="form-control" [attr.maxlength]="fieldMaxLengths.State_UI_ID"
                         placeholder="Enter  State UI ID# (Required for CO/FL/MN/NY)"
                         appAiHint="State UI ID" [aiHintForm]="icdForm" />
                  <div class="text-right small mt-1"
                       [ngClass]="{'text-danger': f.State_UI_ID.errors?.maxlength,'text-muted': !f.State_UI_ID.errors?.maxlength}">

                    {{ icdForm.get('State_UI_ID')?.value?.length || 0 }}/{{ fieldMaxLengths.State_UI_ID }}

                  </div>
                  <div *ngIf="submitted && f.State_UI_ID.errors" class="invalid-feedback">
                    <div *ngIf="f.State_UI_ID.errors.required"> State UI ID# (Required for CO/FL/MN/NY)  is required</div>
                    <div *ngIf="f.State_UI_ID.errors.maxlength">
                      Maximum {{ fieldMaxLengths.State_UI_ID }} characters allowed
                    </div>

                  </div>


                </div>
              </div>

            </div>

            <div class="row">


              <div class="col-sm-4">

                <div class="form-group">
                  <div class="col-md-12">

                    <label class="col-form-label " *ngIf="selectedCountry == 'US'" for="New_Location_out_state">Is new location out of state <code>*</code></label>
                    <label class="col-form-label " *ngIf="selectedCountry == 'Canada'" for="New_Location_out_state">Is new location out of province <code>*</code></label>
                    <select formControlName="New_Location_out_state" class="form-control" (change)="onChange_outofState($event)" [ngClass]="{ 'is-invalid': submitted && f.New_Location_out_state.errors }">
                      <option value="" disabled>Please Select</option>
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </select>
                    <div *ngIf="submitted && f.New_Location_out_state.errors" class="invalid-feedback">
                      <div *ngIf="f.New_Location_out_state.errors.required">New location out of state  is required</div>
                    </div>

                  </div>
                </div>

              </div>
              <div class="col-sm-4">

                <div class="form-group">
                  <div class="col-md-12">
                    <label class="col-form-label " for="Is_storage_location">Is this a storage location
                    <code>*</code></label>
                    <select formControlName="Is_storage_location" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.Is_storage_location.errors }">
                      <option value="" disabled>Please Select</option>
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </select>
                    <div *ngIf="submitted && f.Is_storage_location.errors" class="invalid-feedback">
                      <div *ngIf="f.Is_storage_location.errors.required">storage location  is required</div>
                    </div>

                  </div>
                </div>

              </div>
              <div class="col-sm-4">

                <div class="form-group">
                  <div class="col-md-12">
                    <label class="col-form-label " for="Main_or_Satellite">Is this a Main or Satellite location?
                    <code>*</code></label>
                    <select formControlName="Main_or_Satellite" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.Main_or_Satellite.errors }">
                      <option value="" disabled>Please Select</option>
                      <option value="Main">Main</option>
                      <option value="Satellite">Satellite</option>
                    </select>
                    <div *ngIf="submitted && f.Main_or_Satellite.errors" class="invalid-feedback">
                      <div *ngIf="f.Main_or_Satellite.errors.required">Main or Satellite location is required</div>
                    </div>

                  </div>
                </div>

              </div>


              <div class="col-sm-4">
                <div class="form-group">

                  <div class="col-md-12">

                    <label class="col-form-label  col-md-12" for="login-First_Date_New_Address">First Day at New Address <code>*</code></label>
                    <div class="input-group date" id="reservationdate" data-target-input="nearest">
                      <input type="text" formControlName="First_Date_New_Address" data-target="#reservationdate" autocomplete="off"
                             id="First_Date_New_Address" placeholder="Select First Day at New Address"
                             class="form-control" [ngClass]="{'is-valid': submitted && f.First_Date_New_Address.valid, 'is-invalid' : submitted && !f.First_Date_New_Address.valid}"
                             required
                             appAiHint="First Day at New Address" [aiHintForm]="icdForm"
                             />
                      <div class="input-group-append" style="pointer-events: none;" data-target="#reservationdate" data-toggle="datetimepicker">
                        <div class="input-group-text"><i class="fa fa-calendar"></i></div>
                      </div>
                      <div *ngIf="submitted && f.First_Date_New_Address.errors" class="invalid-feedback">
                        <div *ngIf="f.First_Date_New_Address.errors.required">First Day at New Address is required</div>
                        <div *ngIf="f.First_Date_New_Address.errors.pattern">First Day at New Address must be a valid date in the format MM-DD-YYYY</div>
                        <div *ngIf="f.First_Date_New_Address.errors.dateNotLessThanToday">First Day at New Address cannot be less than today's date.</div>
                      </div>


                    </div>


                  </div>

                </div>
              </div>

              <div class="col-sm-4">
                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-New_Address">New Address to be Insured<code>*</code></label>
                  <input type="text" formControlName="New_Address" class="form-control" [attr.maxlength]="fieldMaxLengths.New_Address"
                         [ngClass]="{'is-valid': f.New_Address.valid, 'is-invalid' : submitted && !f.New_Address.valid}" placeholder="Enter New Address to be Insured"
                         appAiHint="New Address" [aiHintForm]="icdForm" />
                  <div class="text-right small mt-1"
                       [ngClass]="{'text-danger': f.New_Address.errors?.maxlength,'text-muted': !f.New_Address.errors?.maxlength}">

                    {{ icdForm.get('New_Address')?.value?.length || 0 }}/{{ fieldMaxLengths.New_Address }}

                  </div>
                  <div *ngIf="submitted && f.New_Address.errors" class="invalid-feedback">
                    <div *ngIf="f.New_Address.errors.required">New Address to be Insured  is required</div>
                    <div *ngIf="f.New_Address.errors.maxlength">
                      Maximum {{ fieldMaxLengths.New_Address }} characters allowed
                    </div>
                  </div>

                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-Company_Address2">Address 2(e.g. Suite 100)</label>
                  <input type="text" formControlName="Company_Address2" class="form-control" [attr.maxlength]="fieldMaxLengths.Company_Address2"
                         placeholder="Enter Address 2 "
                         appAiHint="Company Address 2" [aiHintForm]="icdForm" />
                  <div class="text-right small mt-1"
                       [ngClass]="{'text-danger': f.Company_Address2.errors?.maxlength,'text-muted': !f.Company_Address2.errors?.maxlength}">

                    {{ icdForm.get('Company_Address2')?.value?.length || 0 }}/{{ fieldMaxLengths.Company_Address2 }}

                  </div>
                  <div *ngIf="submitted && f.Company_Address2.errors" class="invalid-feedback">
                    <div *ngIf="f.Company_Address2.errors.required">Address 2  is required</div>
                    <div *ngIf="f.Company_Address2.errors.maxlength">
                      Maximum {{ fieldMaxLengths.Company_Address2 }} characters allowed
                    </div>
                  </div>

                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-Company_City">City <code>*</code></label>
                  <input type="text" formControlName="Company_City" class="form-control" [attr.maxlength]="fieldMaxLengths.Company_City"
                         [ngClass]="{'is-valid': f.Company_City.valid, 'is-invalid' : submitted && !f.Company_City.valid}" placeholder="Enter  City"
                         appAiHint="Company City" [aiHintForm]="icdForm" />
                  <div class="text-right small mt-1"
                       [ngClass]="{'text-danger': f.Company_City.errors?.maxlength,'text-muted': !f.Company_City.errors?.maxlength}">

                    {{ icdForm.get('Company_City')?.value?.length || 0 }}/{{ fieldMaxLengths.Company_City }}

                  </div>
                  <div *ngIf="submitted && f.Company_City.errors" class="invalid-feedback">
                    <div *ngIf="f.Company_City.errors.required">City is required</div>
                    <div *ngIf="f.Company_City.errors.maxlength">
                      Maximum {{ fieldMaxLengths.Company_City }} characters allowed
                    </div>
                  </div>

                </div>
              </div>
              <div class="col-sm-4" *ngIf="selectedCountry == 'US'">
                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-Company_Country">County <code>*</code></label>
                  <input type="text" formControlName="Company_Country" class="form-control" [attr.maxlength]="fieldMaxLengths.Company_Country"
                         [ngClass]="{'is-valid': f.Company_Country.valid, 'is-invalid' : submitted && !f.Company_Country.valid}" placeholder="Enter County"
                         appAiHint="Company County" [aiHintForm]="icdForm" />
                  <div class="text-right small mt-1"
                       [ngClass]="{'text-danger': f.Company_Country.errors?.maxlength,'text-muted': !f.Company_Country.errors?.maxlength }">

                    {{ icdForm.get('Company_Country')?.value?.length || 0 }}/{{ fieldMaxLengths.Company_Country }}

                  </div>
                  <div *ngIf="submitted && f.Company_Country.errors" class="invalid-feedback">
                    <div *ngIf="f.Company_Country.errors.required">County is required</div>
                    <div *ngIf="f.Company_Country.errors.maxlength">
                      Maximum {{ fieldMaxLengths.Company_Country }} characters allowed
                    </div>
                  </div>

                </div>
              </div>
              <div class="col-sm-4" *ngIf="selectedCountry == 'US'">

                <div class="form-group">

                  <div class="col-md-12">
                    <label class="form-label">State  <code>*</code></label>

                    <ng-select [searchable]="true" (change)="onStateChange($event)" formControlName="Company_State"
                               [ngClass]="{'is-valid': f.Company_State.valid, 'is-invalid' : submitted && !f.Company_State.valid}">
                      <ng-option *ngFor="let o of ddlUSStates"
                                 [value]="o.value">
                        {{ o.name }}
                      </ng-option>
                    </ng-select>
                    <div *ngIf="submitted && f.Company_State.errors" class="invalid-feedback">
                      <div *ngIf="f.Company_State.errors.required">State is required</div>
                    </div>


                  </div>




                </div>
              </div>


              <div class="col-sm-4" *ngIf="selectedCountry == 'Canada'">

                <div class="form-group">

                  <div class="col-md-12">
                    <label class="form-label">Province <code>*</code></label>
                    <select formControlName="Company_Province" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.Company_Province.errors }">
                      <option value="" disabled>Please Select</option>

                      <option *ngFor="let c of ddlCAProvinence" [ngValue]="c.value">{{ c.name }}</option>
                    </select>
                    <div *ngIf="submitted && f.Company_Province.errors" class="invalid-feedback">
                      <div *ngIf="f.Company_Province.errors.required">Province  is required</div>
                    </div>


                  </div>




                </div>
              </div>



              <div class="col-sm-4">
                <div class="form-group">
                  <label *ngIf="selectedCountry == 'Canada'" class="col-form-label  col-md-12" for="login-Company_Postal_Code">Postal Code (Zip) <code>*</code></label>
                  <label *ngIf="selectedCountry == 'US'" class="col-form-label  col-md-12" for="login-Company_Postal_Code">Zip Code <code>*</code></label>
                  <input type="text" formControlName="Company_Postal_Code" class="form-control" [attr.maxlength]="fieldMaxLengths.Company_Postal_Code"
                         [ngClass]="{'is-valid': f.Company_Postal_Code.valid, 'is-invalid' : submitted && !f.Company_Postal_Code.valid}" placeholder="Enter  postal Code (Zip)"
                         appAiHint="Company Postal Code" [aiHintForm]="icdForm" />
                  <div class="text-right small mt-1"
                       [ngClass]="{'text-danger': f.Company_Postal_Code.errors?.maxlength,'text-muted': !f.Company_Postal_Code.errors?.maxlength}">

                    {{ icdForm.get('Company_Postal_Code')?.value?.length || 0 }}/{{ fieldMaxLengths.Company_Postal_Code }}

                  </div>
                  <div *ngIf="submitted && f.Company_Postal_Code.errors" class="invalid-feedback">
                    <div *ngIf="f.Company_Postal_Code.errors.required">Postal Code  is required</div>
                    <div *ngIf="f.Company_Postal_Code.errors.maxlength">
                      Maximum {{ fieldMaxLengths.Company_Postal_Code }} characters allowed
                    </div>
                  </div>

                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-Owner_Mobile_Phone">Mobile Phone<code>*</code></label>
                  <input type="text" formControlName="Owner_Mobile_Phone" class="form-control" appPhoneNumberMask [phoneNumberFormat]="'elevenDigit'" [attr.maxlength]="fieldMaxLengths.Owner_Mobile_Phone"
                         [ngClass]="{'is-valid': f.Owner_Mobile_Phone.valid, 'is-invalid' : submitted && !f.Owner_Mobile_Phone.valid}" placeholder="X-XXX-XXX-XXXX "
                         appAiHint="Owner Mobile Phone" [aiHintForm]="icdForm" />
                  <div class="text-right small mt-1"
                       [ngClass]="{'text-danger': f.Owner_Mobile_Phone.errors?.maxlength,'text-muted': !f.Owner_Mobile_Phone.errors?.maxlength}">

                    {{ icdForm.get('Owner_Mobile_Phone')?.value?.length || 0 }}/{{ fieldMaxLengths.Owner_Mobile_Phone }}

                  </div>
                  <div *ngIf="submitted && f.Owner_Mobile_Phone.errors" class="invalid-feedback">
                    <div *ngIf="f.Owner_Mobile_Phone.errors.required">Mobile Phone   is required</div>
                    <div *ngIf="f.Owner_Mobile_Phone.errors.maxlength">
                      Maximum {{ fieldMaxLengths.Owner_Mobile_Phone }} characters allowed
                    </div>
                    <div>Mobile phone must be 11 digits starting with 1 (country code).</div>
                  </div>

                </div>
              </div>
              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-Company_Office_Phone">Office Phone <code>*</code></label>
                  <input type="text" formControlName="Company_Office_Phone" class="form-control" appPhoneNumberMask [phoneNumberFormat]="'tenDigit'" [attr.maxlength]="fieldMaxLengths.Company_Office_Phone"
                         [ngClass]="{'is-valid': f.Company_Office_Phone.valid, 'is-invalid' : submitted && !f.Company_Office_Phone.valid}"
                         placeholder="XXX-XXX-XXXX"
                         appAiHint="Company Office Phone" [aiHintForm]="icdForm" />
                  <!--<input type="text" formControlName="Company_Office_Phone" class="form-control" phoneMask
  [preValue]="f.value.Company_Office_Phone" [phoneControl]="f.controls['Company_Office_Phone']" maxlength="14"
  [ngClass]="{'is-valid': f.Company_Office_Phone.valid, 'is-invalid' : submitted && !f.Company_Office_Phone.valid}"
  placeholder="Enter  Office Phone"
  appAiHint="Company Office Phone" [aiHintForm]="icdForm" />-->
                  <div class="text-right small mt-1"
                       [ngClass]="{'text-danger': f.Company_Office_Phone.errors?.maxlength,'text-muted': !f.Company_Office_Phone.errors?.maxlength}">

                    {{ icdForm.get('Company_Office_Phone')?.value?.length || 0 }}/{{ fieldMaxLengths.Company_Office_Phone }}

                  </div>

                  <div *ngIf="submitted && f.Company_Office_Phone.errors" class="invalid-feedback">
                    <div *ngIf="f.Company_Office_Phone.errors.required">Office Phone  is required</div>
                    <div *ngIf="f.Company_Office_Phone.errors.maxlength">
                      Maximum {{ fieldMaxLengths.Company_Office_Phone }} characters allowed
                    </div>
                  </div>

                </div>
              </div>

              <div class="col-sm-4">
                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-Sales_tax_perc">New State Sales Tax % <code>*</code></label>
                  <input type="text" formControlName="Sales_tax_perc" class="form-control" [attr.maxlength]="fieldMaxLengths.Sales_tax_perc"
                         [ngClass]="{'is-valid': f.Sales_tax_perc.valid, 'is-invalid' : submitted && !f.Sales_tax_perc.valid}" placeholder="Enter  New State Sales Tax Percentage "
                         appAiHint="Sales Tax Percentage" [aiHintForm]="icdForm" />
                  <div class="text-right small mt-1"
                       [ngClass]="{'text-danger': f.Sales_tax_perc.errors?.maxlength,'text-muted': !f.Sales_tax_perc.errors?.maxlength }">

                    {{ icdForm.get('Sales_tax_perc')?.value?.length || 0 }}/{{ fieldMaxLengths.Sales_tax_perc }}

                  </div>
                  <div *ngIf="submitted && f.Sales_tax_perc.errors" class="invalid-feedback">
                    <div *ngIf="f.Sales_tax_perc.errors.required">New State Sales Tax Percentage  is required</div>
                    <div *ngIf="f.Sales_tax_perc.errors.maxlength">
                      Maximum {{ fieldMaxLengths.Sales_tax_perc }} characters allowed
                    </div>
                  </div>

                </div>
              </div>






            </div>

            <div class="col-sm-12">

                <div class="form-group">
                    <div class="custom-control custom-switch custom-switch-on-success">
                        <input type="checkbox" formControlName="isNew_DBA_Name" (change)="onChangeisNewDBA()" class="custom-control-input" id="isNew_DBA_Name">
                        <label class="custom-control-label" for="isNew_DBA_Name">Is this a new DBA? </label>

                    </div>
                </div>
                <div class="col-sm-4" *ngIf="isNew_DBA_Name">
                    <div class="form-group">
                        <label class="col-form-label  col-md-12" for="login-New_DBA_Name">New DBA Name </label>
                        <input type="text" formControlName="New_DBA_Name" class="form-control" [attr.maxlength]="fieldMaxLengths.New_DBA_Name"
                               [ngClass]="{'is-valid': f.New_DBA_Name.valid, 'is-invalid' : submitted && !f.New_DBA_Name.valid}" placeholder="Enter New DBA Name"
                               appAiHint="New DBA Name" [aiHintForm]="icdForm" />
                        <div class="text-right small mt-1"
                             [ngClass]="{'text-danger': f.New_DBA_Name.errors?.maxlength,'text-muted': !f.New_DBA_Name.errors?.maxlength}">

                            {{ icdForm.get('New_DBA_Name')?.value?.length || 0 }}/{{ fieldMaxLengths.New_DBA_Name }}

                        </div>
                        <div *ngIf="submitted && f.New_DBA_Name.errors" class="invalid-feedback">
                            <div *ngIf="f.New_DBA_Name.errors.required">New DBA Name is required</div>
                            <div *ngIf="f.New_DBA_Name.errors.maxlength">
                                Maximum {{ fieldMaxLengths.New_DBA_Name }} characters allowed
                            </div>
                        </div>

                    </div>
                </div>

                <!-- NEW: DBA Preference Questions -->
                <div class="col-sm-12" *ngIf="isNew_DBA_Name">
                    <div class="card card-info">
                        <div class="card-header">
                            <h4 class="card-title">DBA Preference</h4>
                        </div>
                        <div class="card-body">

                            <!-- Question 1: Is this Preferred DBA? -->
                            <div class="form-group">
                                <label>Is this the ICD's Preferred DBA? <code>*</code></label>
                                <div class="form-check">
                                    <input type="radio" formControlName="isPreferredDBA" value="Yes"
                                           id="isPreferredDBA_Yes" class="form-check-input"
                                           (change)="onChangePreferredDBA()" />
                                    <label class="form-check-label" for="isPreferredDBA_Yes">
                                        Yes
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input type="radio" formControlName="isPreferredDBA" value="No"
                                           id="isPreferredDBA_No" class="form-check-input"
                                           (change)="onChangePreferredDBA()" />
                                    <label class="form-check-label" for="isPreferredDBA_No">
                                        No
                                    </label>
                                </div>
                                <div *ngIf="submitted && f.isPreferredDBA.errors" class="invalid-feedback d-block">
                                    <div *ngIf="f.isPreferredDBA.errors.required">Is this the ICD's Preferred DBA is required</div>
                                </div>
                            </div>

                            <!-- Question 2: Preferred DBA Name (conditional) -->
                            <div class="form-group" *ngIf="f.isPreferredDBA.value === 'No'">
                                <label class="col-form-label col-md-12" for="login-preferredDBAName">
                                    What is the ICD's preferred DBA Name? <code>*</code>
                                </label>
                                <input type="text" formControlName="preferredDBAName"
                                       class="form-control"
                                       [attr.maxlength]="fieldMaxLengths.preferredDBAName"
                                       [ngClass]="{'is-valid': f.preferredDBAName.valid, 'is-invalid' : submitted && !f.preferredDBAName.valid}"
                                       placeholder="Enter preferred DBA name"
                                       appAiHint="Preferred DBA Name" [aiHintForm]="icdForm" />
                                <div class="text-right small mt-1"
                                     [ngClass]="{'text-danger': f.preferredDBAName.errors?.maxlength,'text-muted': !f.preferredDBAName.errors?.maxlength}">
                                    {{ icdForm.get('preferredDBAName')?.value?.length || 0 }}/{{ fieldMaxLengths.preferredDBAName }}
                                </div>
                                <div *ngIf="submitted && f.preferredDBAName.errors" class="invalid-feedback d-block">
                                    <div *ngIf="f.preferredDBAName.errors.required">Preferred DBA Name is required</div>
                                    <div *ngIf="f.preferredDBAName.errors.maxlength">
                                        Maximum {{ fieldMaxLengths.preferredDBAName }} characters allowed
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>



            <!--<div class="form-group pull-right" *ngIf="btnDisplay">
    <button type="button" class="btn btn-primary" (click)="saveSection1()">Save Info</button>
  </div>-->

          </div>

        </div>




        <div class="card card-secondary ">
          <div class="card-header">
            <h3 class="card-title">  Campaign(s)  </h3>
            <div class="card-tools">
              <button type="button" class="btn btn-tool" data-card-widget="collapse">
                <i class="fas fa-minus"></i>
              </button>
            </div>
          </div>
          <!-- /.card-header -->
          <div class="card-body">
            <div class="row" *ngIf="selectedCountry == 'Canada'">
              <span>Select all Campaigns that apply.<code>*</code></span>
              <div class="col-md-4" *ngFor="let item of Canada_campaignData">
                <div class="form-group">
                  <div class="custom-control custom-switch  custom-switch-on-success">
                    <input type="checkbox" class="custom-control-input" [id]="item.id" [value]="item.campaignName"
                           [disabled]="isCheckboxesDisabled" [checked]="Canada_Campaigns_selectedItems.includes(item.campaignName)" (change)="onCheckboxChange_Canada_Campaigns($event, item.campaignName)">
                    <label class="custom-control-label" [for]="item.id">{{ item.campaignName }}</label>
                  </div>
                </div>

              </div>
              
            </div>
            <div class="row" *ngIf="selectedCountry == 'Canada'">
              <span>Select all Due Delegence Campaigns that apply.<code>*</code></span>
              <div class="col-md-4" *ngFor="let item of Canada_campaignData_DD">
                <div class="form-group">
                  <div class="custom-control custom-switch  custom-switch-on-success">
                    <input type="checkbox" class="custom-control-input" [id]="item.id" [value]="item.campaignName"
                           [disabled]="isCheckboxesDisabled" [checked]="Canada_Campaigns_selectedItems.includes(item.campaignName)" (change)="onCheckboxChange_Canada_Campaigns($event, item.campaignName)">
                    <label class="custom-control-label" [for]="item.id">{{ item.campaignName }}</label>
                  </div>
                </div>

              </div>
              <span *ngIf="Canada_Campaigns_isSelectedItemsinvalid" style="color:red;">at least select one option in Campaigns</span>
            </div>
            <div class="row" *ngIf="selectedCountry == 'US'">
              <span>Select all Campaigns that apply.<code>*</code></span>
              <div class="col-md-4" *ngFor="let item of US_campaignData">
                <div class="form-group">
                  <div class="custom-control custom-switch  custom-switch-on-success">
                    <input type="checkbox" class="custom-control-input" [id]="item.id"
                           [disabled]="isCheckboxesDisabled" [checked]="US_Campaigns_selectedItems.includes(item.campaignName)"
                           [value]="item.campaignName" (change)="onCheckboxChange_US_Campaigns($event, item.campaignName)">
                    <label class="custom-control-label" [for]="item.id">{{ item.campaignName }}</label>
                  </div>
                </div>

              </div>
              
            </div>

            <div class="row" *ngIf="selectedCountry == 'US'">
              <span>Select all Due Diligence Campaigns that apply.<code>*</code></span>
              <div class="col-md-4" *ngFor="let item of US_campaignData_DD">
                <div class="form-group">
                  <div class="custom-control custom-switch  custom-switch-on-success">
                    <input type="checkbox" class="custom-control-input" [id]="item.id"
                           [disabled]="isCheckboxesDisabled" [checked]="US_Campaigns_selectedItems.includes(item.campaignName)"
                           [value]="item.campaignName" (change)="onCheckboxChange_US_Campaigns($event, item.campaignName)">
                    <label class="custom-control-label" [for]="item.id">{{ item.campaignName }}</label>
                  </div>
                </div>

              </div>
              <span *ngIf="US_Campaigns_isSelectedItemsinvalid" style="color:red;">at least select one option in Campaigns</span>
              
            </div>
            <div class="col-sm-4" *ngIf="isTestCampaign">
              <div class="form-group">
                <label class="col-form-label  col-md-12" for="login-TestCampaignNotListed">TestCampaign(NotListed) <code>*</code></label>
                <input type="text" formControlName="TestCampaignNotListed" class="form-control" [attr.maxlength]="fieldMaxLengths.TestCampaignNotListed"
                       [ngClass]="{'is-valid': f.TestCampaignNotListed.valid, 'is-invalid' : submitted && !f.TestCampaignNotListed.valid}" placeholder="Enter  TestCampaignNotListed"
                       appAiHint="Test Campaign Not Listed" [aiHintForm]="icdForm" />
                <div class="text-right small mt-1"
                     [ngClass]="{'text-danger': f.TestCampaignNotListed.errors?.maxlength,'text-muted': !f.TestCampaignNotListed.errors?.maxlength}">

                  {{ icdForm.get('TestCampaignNotListed')?.value?.length || 0 }}/{{ fieldMaxLengths.TestCampaignNotListed }}

                </div>
                <div *ngIf="submitted && f.TestCampaignNotListed.errors" class="invalid-feedback">
                  <div *ngIf="f.TestCampaignNotListed.errors.required">Test Campaign Not Listed is required</div>
                  <div *ngIf="f.TestCampaignNotListed.errors.maxlength">
                    Maximum {{ fieldMaxLengths.TestCampaignNotListed }} characters allowed
                  </div>
                </div>

              </div>
            </div>
            <!-- /.card-body -->
            <!--<div class="form-group pull-right" *ngIf="btnDisplay">
        <button type="button" class="btn btn-primary" (click)="saveSection7()">Save Campaign Info</button>
      </div>-->
          </div>
        </div>


        <div class="card card-secondary hide">
          <div class="card-header">
            <h3 class="card-title"> Retailers  </h3>
            <div class="card-tools">
              <button type="button" class="btn btn-tool" data-card-widget="collapse">
                <i class="fas fa-minus"></i>
              </button>
            </div>
          </div>
          <!-- /.card-header -->
          <div class="card-body">
            <div class="row" *ngIf="selectedCountry == 'US'">
              <span>Select all Retailers that apply.<code>*</code></span>

              <div class="col-md-4" *ngFor="let item of US_retailsData">
                <div class="form-group">
                  <div class="custom-control custom-switch  custom-switch-on-success">
                    <input type="checkbox" class="custom-control-input" [id]="item.id" [value]="item.value"
                           [disabled]="isCheckboxesDisabled" [checked]="US_Retails_selectedItems.includes(item.name)" (change)="onCheckboxChange_US_Retails($event, item.name)">
                    <label class="custom-control-label" [for]="item.id">{{ item.name }}</label>
                  </div>
                </div>

              </div>
              <span *ngIf="US_Retails_isSelectedItemsinvalid" style="color:red;">select at least one option in retails</span>



            </div>
            <div class="row" *ngIf="selectedCountry == 'Canada'">

              <span>Select all Retailers that apply.<code>*</code></span>
              <div class="col-md-4" *ngFor="let item of Canada_retailsData">
                <div class="form-group">
                  <div class="custom-control custom-switch  custom-switch-on-success">
                    <input type="checkbox" class="custom-control-input" [id]="item.id"
                           [disabled]="isCheckboxesDisabled" [checked]="Canada_Retails_selectedItems.includes(item.name)"
                           [value]="item.value" (change)="onCheckboxChange_Canada_Retails($event, item.name)">
                    <label class="custom-control-label" [for]="item.id">{{ item.name }}</label>
                  </div>
                </div>

              </div>
              <span *ngIf="Canada_Retails_isSelectedItemsinvalid" style="color:red;">select at least one option in retails</span>

            </div>

            <!-- /.card-body -->
            <!--<div class="form-group pull-right" *ngIf="btnDisplay">
        <button type="button" class="btn btn-primary" (click)="saveSection8()">Save Retailers Info</button>
      </div>-->
          </div>
        </div>


        <div class="card card-secondary hide">
          <div class="card-header">
            <h3 class="card-title">Employee Disability Insurance</h3>
            <div class="card-tools">
              <button type="button" class="btn btn-tool" data-card-widget="collapse">
                <i class="fas fa-minus"></i>
              </button>
            </div>
          </div>
          <!-- /.card-header -->
          <div class="card-body">

            (Mandatory disability coverage for NY and Hawaii)
            <div class="row">

              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-Male_Emp"># of Male Employees</label>
                  <div class="col-md-12">
                    <input type="text" formControlName="Male_Emp" id="login-Male_Emp" name="Male_Emp" [attr.maxlength]="fieldMaxLengths.Male_Emp" placeholder="Enter Male Employees" autocomplete="Male_Emp"
                           class="form-control"
                           appAiHint="Male Employees" [aiHintForm]="icdForm" />
                    <div class="text-right small mt-1"
                         [ngClass]="{'text-danger': f.Male_Emp.errors?.maxlength,'text-muted': !f.Male_Emp.errors?.maxlength}">

                      {{ icdForm.get('Male_Emp')?.value?.length || 0 }}/{{ fieldMaxLengths.Male_Emp }}

                    </div>
                    <div *ngIf="submitted && f.Male_Emp.errors"
                         class="invalid-feedback">

                      <div *ngIf="f.Male_Emp.errors.maxlength">
                        Maximum {{ fieldMaxLengths.Male_Emp }} characters allowed
                      </div>

                    </div>

                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-FeMale_Emp"> # of Female Employees </label>
                  <div class="col-md-12">
                    <input type="text" formControlName="FeMale_Emp" id="login-FeMale_Emp" name="FeMale_Emp" [attr.maxlength]="fieldMaxLengths.FeMale_Emp" placeholder="Enter Female Employees"
                           autocomplete="current-FeMale_Emp" class="form-control"
                           appAiHint="Female Employees" [aiHintForm]="icdForm" />
                    <div class="text-right small mt-1"
                         [ngClass]="{'text-danger': f.FeMale_Emp.errors?.maxlength,'text-muted': !f.FeMale_Emp.errors?.maxlength}">

                      {{ icdForm.get('FeMale_Emp')?.value?.length || 0 }}/{{ fieldMaxLengths.FeMale_Emp }}

                    </div>
                    <div *ngIf="submitted && f.FeMale_Emp.errors"
                         class="invalid-feedback">

                      <div *ngIf="f.FeMale_Emp.errors.maxlength">
                        Maximum {{ fieldMaxLengths.FeMale_Emp }} characters allowed
                      </div>

                    </div>

                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-HUB_Manager_Contact_Email">NY or HI Disability Form</label>
                  <div class="col-md-12">

                    <input type="file"  formControlName="Disability_Form" class="form-control"
                           [ngClass]="{'is-valid': f.Disability_Form.valid, 'is-invalid' : submitted && !f.Disability_Form.valid}" 
                           (change)="onFileSelected($event, 'Disability_Form')" />
                    <ng-container *ngTemplateOutlet="uploadStatus; context: { $implicit: 'Disability_Form' }"></ng-container>


                    <div class="invalid-feedback" *ngIf="isInvalid('Disability_Form')">
                      <div *ngIf="icdForm.get('Disability_Form').errors.required">Disability_Form is required</div>
                      <div *ngIf="icdForm.get('Disability_Form').errors.maxFilesExceeded">Maximum number of files exceeded.</div>
                      <div *ngIf="icdForm.get('Disability_Form').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                      <div *ngIf="icdForm.get('Disability_Form').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                    </div>

                  </div>
                </div>
              </div>

            </div>

            <!-- /.card-body -->
          </div>
        </div>


        <div class="card card-secondary">
          <div class="card-header">
            <h3 class="card-title">
              Documents  -  Provide Copies of the Following:
            </h3>
            <div class="card-tools">
              <button type="button" class="btn btn-tool" data-card-widget="collapse">
                <i class="fas fa-minus"></i>
              </button>
            </div>
          </div>
          <!-- /.card-header -->
          <div class="card-body">


            <div class="row">

              <div class="col-sm-6">
                <div class="form-group">

                  <label class="col-form-label " for="isInsuranceRequired">Does the ICD want Herb Joy Enterprises to refer it to an insurance broker ? <code>*</code></label>
                  <select formControlName="isInsuranceRequired" class="form-control" (change)="ChangeIsInsurance()" [ngClass]="{ 'is-invalid': submitted && f.isInsuranceRequired.errors }">
                    <option value="" disabled>Please Select</option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                  <div *ngIf="submitted && f.isInsuranceRequired.errors" class="invalid-feedback">
                    <div *ngIf="f.isInsuranceRequired.errors.required">Is the ICD providing their own Insurance  is required</div>
                  </div>
                </div>

              </div>

              <div class="col-sm-6">
                <div class="form-group">

                  <label class="col-form-label  col-md-12" for="login-Attach_US_Certificate_of_Insurance">Certificate(s) of Insurance (if applicable)</label>
                  <input type="file"  formControlName="Attach_US_Certificate_of_Insurance"
                         class="form-control" 
                         [ngClass]="{'is-valid': f.Attach_US_Certificate_of_Insurance.valid  &&
                        f.Attach_US_Certificate_of_Insurance.value, 'is-invalid' : submitted && !f.Attach_US_Certificate_of_Insurance.valid}" 
                         (change)="onFileSelected($event, 'Attach_US_Certificate_of_Insurance')" />
                  <ng-container *ngTemplateOutlet="uploadStatus; context: { $implicit: 'Attach_US_Certificate_of_Insurance' }"></ng-container>


                  <div class="invalid-feedback" *ngIf="isInvalid('Attach_US_Certificate_of_Insurance')">
                    <div *ngIf="icdForm.get('Attach_US_Certificate_of_Insurance').errors.required">Attach_US_Certificate_of_Insurance is required</div>
                    <div *ngIf="icdForm.get('Attach_US_Certificate_of_Insurance').errors.maxFilesExceeded">Maximum number of files exceeded.</div>
                    <div *ngIf="icdForm.get('Attach_US_Certificate_of_Insurance').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                    <div *ngIf="icdForm.get('Attach_US_Certificate_of_Insurance').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                  </div>
                  <div class="mt-1" *ngIf="verificationState['Attach_US_Certificate_of_Insurance']">
                    <span *ngIf="verificationState['Attach_US_Certificate_of_Insurance'] === 'verifying'" class="text-secondary small"><i class="fa fa-spinner fa-spin"></i> Verifying document...</span>
                    <span *ngIf="verificationState['Attach_US_Certificate_of_Insurance'] === 'pass'" class="text-success small"><i class="fa fa-check-circle"></i> Document verified</span>
                    <span *ngIf="verificationState['Attach_US_Certificate_of_Insurance'] === 'warn'" class="text-warning small"><i class="fa fa-exclamation-triangle"></i> Accepted with notes</span>
                    <span *ngIf="verificationState['Attach_US_Certificate_of_Insurance'] === 'warn_disabled_never_shown'" class="text-warning small"><i class="fa fa-exclamation-triangle"></i> Verification failed</span>
                    <ul *ngIf="verificationIssues['Attach_US_Certificate_of_Insurance']?.length > 0" class="mt-1 mb-0 pl-3 small" [class.text-warning]="verificationState['Attach_US_Certificate_of_Insurance'] === 'warn_disabled_never_shown'" [class.text-warning]="verificationState['Attach_US_Certificate_of_Insurance'] === 'warn'" style="list-style: disc;">
                      <li *ngFor="let issue of verificationIssues['Attach_US_Certificate_of_Insurance']">{{ issue }}</li>
                    </ul>
                  </div>


                </div>
              </div>

              <div class="col-sm-6 ">
                <div class="form-group">

                  <label class="col-form-label  col-md-12" for="login-Workers_Compensation">Proof of Worker's Compensation Coverage</label>
                  <input type="file" formControlName="Workers_Compensation" class="form-control" 
                         [ngClass]="{'is-valid': f.Workers_Compensation.valid && f.Workers_Compensation.value, 'is-invalid' : submitted && !f.Workers_Compensation.valid}" 
                         (change)="onFileSelected($event, 'Workers_Compensation')" />
                  <ng-container *ngTemplateOutlet="uploadStatus; context: { $implicit: 'Workers_Compensation' }"></ng-container>

                  <div class="invalid" style="color:red !important" *ngIf="isInvalid('Workers_Compensation')">
                    <div *ngIf="icdForm.get('Workers_Compensation').errors.required">Workers_Compensation is required</div>
                    <div *ngIf="icdForm.get('Workers_Compensation').errors.maxFilesExceeded">Maximum number of files exceeded.</div>
                    <div *ngIf="icdForm.get('Workers_Compensation').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                    <div *ngIf="icdForm.get('Workers_Compensation').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                  </div>

                </div>
              </div>
              <div class="col-sm-6 hide">
                <div class="form-group" *ngIf="selectedCountry == 'US'">

                  <label class="col-form-label  col-md-12" for="login-Node_Form">Node Form</label>
                  <input type="file" formControlName="Node_Form" class="form-control"
                         [ngClass]="{'is-valid': f.Node_Form.valid  && f.Node_Form.value, 'is-invalid' : submitted && !f.Node_Form.valid}" 
                         (change)="onFileSelected($event, 'Node_Form')" />
                  <ng-container *ngTemplateOutlet="uploadStatus; context: { $implicit: 'Node_Form' }"></ng-container>

                  <div class="invalid" style="color:red !important" *ngIf="isInvalid('Node_Form')">
                    <div *ngIf="icdForm.get('Node_Form').errors.required">Node Form is required</div>
                    <div *ngIf="icdForm.get('Node_Form').errors.maxFilesExceeded">Maximum number of files exceeded.</div>
                    <div *ngIf="icdForm.get('Node_Form').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                    <div *ngIf="icdForm.get('Node_Form').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                  </div>

                </div>
              </div>
              <!--<div class="col-sm-6 ">
                <div class="form-group" *ngIf="selectedCountry == 'Canada'">

                  <label class="col-form-label  col-md-12" for="login-Extra_Provincial_License">Extra Provincial  License</label>
                  <input type="file" formControlName="Extra_Provincial_License" class="form-control" (change)="onFileSelected($event, 'Extra_Provincial_License')" />

                  <div class="invalid" style="color:red !important" *ngIf="isInvalid('Extra_Provincial_License')">
                    <div *ngIf="icdForm.get('Extra_Provincial_License').errors.required">Extra Provincial License is required</div>
                    <div *ngIf="icdForm.get('Extra_Provincial_License').errors.maxFilesExceeded">Maximum number of files exceeded.</div>
                    <div *ngIf="icdForm.get('Extra_Provincial_License').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                    <div *ngIf="icdForm.get('Extra_Provincial_License').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                  </div>

                </div>
              </div>

              <div class="col-sm-6 " *ngIf="selectedCountry == 'Canada'">
                <div class="form-group" >

                  <label class="col-form-label  col-md-12" for="login-Quebec_Power_of_Attorney">Quebec Power of Attorney – MR-69-V</label>
                  <input type="file" formControlName="Quebec_Power_of_Attorney" class="form-control" (change)="onFileSelected($event, 'Quebec_Power_of_Attorney')" />

                  <div class="invalid" style="color:red !important" *ngIf="isInvalid('Quebec_Power_of_Attorney')">
                    <div *ngIf="icdForm.get('Quebec_Power_of_Attorney').errors.required">Quebec_Power_of_Attorney is required</div>
                    <div *ngIf="icdForm.get('Quebec_Power_of_Attorney').errors.maxFilesExceeded">Maximum number of files exceeded.</div>
                    <div *ngIf="icdForm.get('Quebec_Power_of_Attorney').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                    <div *ngIf="icdForm.get('Quebec_Power_of_Attorney').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                  </div>

                </div>
              </div>-->
              <div class="col-sm-6" *ngIf="isLocation_out_state">


                <div class="form-group">
                  <label class="col-form-label col-md-12" for="login-Attach_Incorporation">Article of Incorporation/ State Qualification <code>*</code></label>
                  <input type="file" formControlName="Attach_Incorporation" (change)="onFileSelected($event, 'Attach_Incorporation')"
                         class="form-control" 
                         [ngClass]="{'is-valid': f.Attach_Incorporation.valid  && f.Attach_Incorporation.value, 'is-invalid' : submitted && !f.Attach_Incorporation.valid}" 
                         />
                  <div class="invalid-feedback" *ngIf="isInvalid('Attach_Incorporation')">
                    <div *ngIf="icdForm.get('Attach_Incorporation').errors.required">Article of Incorporation/ State Qualification is required</div>
                    <div *ngIf="icdForm.get('Attach_Incorporation').errors.maxFilesExceeded">Maximum number of files exceeded.</div>
                    <div *ngIf="icdForm.get('Attach_Incorporation').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                    <div *ngIf="icdForm.get('Attach_Incorporation').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                  </div>
                  <ng-container *ngTemplateOutlet="uploadStatus; context: { $implicit: 'Attach_Incorporation' }"></ng-container>
                  <div class="mt-1" *ngIf="verificationState['Attach_Incorporation']">
                    <span *ngIf="verificationState['Attach_Incorporation'] === 'verifying'" class="text-secondary small"><i class="fa fa-spinner fa-spin"></i> Verifying document...</span>
                    <span *ngIf="verificationState['Attach_Incorporation'] === 'pass'" class="text-success small"><i class="fa fa-check-circle"></i> Document verified</span>
                    <span *ngIf="verificationState['Attach_Incorporation'] === 'warn'" class="text-warning small"><i class="fa fa-exclamation-triangle"></i> Accepted with notes</span>
                    <span *ngIf="verificationState['Attach_Incorporation'] === 'warn_disabled_never_shown'" class="text-warning small"><i class="fa fa-exclamation-triangle"></i> Verification failed</span>
                    <ul *ngIf="verificationIssues['Attach_Incorporation']?.length > 0" class="mt-1 mb-0 pl-3 small" [class.text-warning]="verificationState['Attach_Incorporation'] === 'warn_disabled_never_shown'" [class.text-warning]="verificationState['Attach_Incorporation'] === 'warn'" style="list-style: disc;">
                      <li *ngFor="let issue of verificationIssues['Attach_Incorporation']">{{ issue }}</li>
                    </ul>
                  </div>
                  <!--<a (click)="openFile(fileId, fileName)" href="#" target="_blank">Open File</a>-->

                </div>

              </div>
              <div class="col-sm-6">
                <div class="form-group">

                  <label class="col-form-label  col-md-12" for="login-Attach_DBA_Doc">DBA Document</label>
                  <input type="file" formControlName="Attach_DBA_Doc" class="form-control" (change)="onFileSelected($event, 'Attach_DBA_Doc')"
                         [ngClass]="{'is-valid': f.Attach_DBA_Doc.valid  && f.Attach_DBA_Doc.value, 'is-invalid' : submitted && !f.Attach_DBA_Doc.valid}" />
                  <ng-container *ngTemplateOutlet="uploadStatus; context: { $implicit: 'Attach_DBA_Doc' }"></ng-container>
                  <div class="invalid-feedback" *ngIf="isInvalid('Attach_DBA_Doc')">
                    <div *ngIf="icdForm.get('Attach_DBA_Doc').errors.required">DBA Document is required</div>
                    <div *ngIf="icdForm.get('Attach_DBA_Doc').errors.maxFilesExceeded">Maximum number of files exceeded.</div>
                    <div *ngIf="icdForm.get('Attach_DBA_Doc').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                    <div *ngIf="icdForm.get('Attach_DBA_Doc').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                  </div>

                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">

                  <label class="col-form-label  col-md-12" for="login-Attach_Renter_Insurance">Renter's/Home Owner's Insurance (If based out of house) </label>
                  <input type="file" formControlName="Attach_Renter_Insurance" class="form-control" (change)="onFileSelected($event, 'Attach_Renter_Insurance')"
                         [ngClass]="{'is-valid': f.Attach_Renter_Insurance.valid && f.Attach_Renter_Insurance.value, 'is-invalid' : submitted && !f.Attach_Renter_Insurance.valid}" />
                  <ng-container *ngTemplateOutlet="uploadStatus; context: { $implicit: 'Attach_Renter_Insurance' }"></ng-container>
                  <div class="invalid-feedback" *ngIf="isInvalid('Attach_Renter_Insurance')">
                    <div *ngIf="icdForm.get('Attach_Renter_Insurance').errors.required">Insurance  is required</div>
                    <div *ngIf="icdForm.get('Attach_Renter_Insurance').errors.maxFilesExceeded">Maximum number of files exceeded.</div>
                    <div *ngIf="icdForm.get('Attach_Renter_Insurance').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                    <div *ngIf="icdForm.get('Attach_Renter_Insurance').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                  </div>

                </div>
              </div>






            </div>


            <h6>***</h6>
            <b>FORM MUST BE FULLY COMPLETED IN ORDER FOR COVERAGE TO BE CONSIDERED.  COVERAGE IS NOT BOUND UNTIL CONFIRMED BY INSURER</b>
            <!--<div class="form-group pull-right" *ngIf="btnDisplay">
        <button type="button" class="btn btn-primary" (click)="saveSection5()">Save Docs</button>
      </div>-->
          </div>

        </div>



      <!-- AI Pre-Submit Review Modal -->
      <app-pre-submit-review
        [visible]="showPreSubmitReview"
        [issues]="preSubmitIssues"
        [loading]="preSubmitLoading"
        (dismiss)="onPreSubmitDismiss()"
        (submitAnyway)="onPreSubmitDoSubmit()"
        (recheck)="onPreSubmitRecheck()"
        (autoFix)="onPreSubmitAutoFix($event)"
        (navigateToField)="onPreSubmitNavigate($event)">
      </app-pre-submit-review>
        <div class="mb-3" *ngIf="btnDisplay">


          <button type="submit" class="btn btn-success float-right">
            {{isLoading ? 'Submit' : 'Submit'}}

          </button>


        </div>
  </form>
</div>


